import { render } from "./chatingCustomInfo.vue?vue&type=template&id=39e3cfd0&scoped=true"
import script from "./chatingCustomInfo.vue?vue&type=script&lang=js"
export * from "./chatingCustomInfo.vue?vue&type=script&lang=js"

import "./chatingCustomInfo.vue?vue&type=style&index=0&id=39e3cfd0&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e3cfd0"]])

export default __exports__